interface BrandMarkProps {
  className?: string;
  /** Pixel size — default 28. Scales both width and height proportionally. */
  size?: number;
}

/**
 * The FC Bracket graphic mark.
 *
 * A minimalist glyph of a tournament bracket match: two teams on the
 * left, converging into one winner line on the right. Drawn in the
 * current theme's --primary color.
 *
 *   ┌──
 *   │
 *   ├──
 *   │
 *   └──
 *
 * Rendered in currentColor so it tints volt on the homepage, gold in
 * the authenticated app. Uses square caps for a Nike-style
 * engineered/broadcast feel.
 */
export function BrandMark({ className = "", size = 28 }: BrandMarkProps) {
  return (
    <svg
      viewBox="0 0 28 24"
      width={size}
      height={(size * 24) / 28}
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="square"
      strokeLinejoin="miter"
      className={className}
      aria-hidden
    >
      {/* Top-left match input → vertical → bottom-left match input */}
      <path d="M3 3 H12" />
      <path d="M12 3 V21" />
      <path d="M3 21 H12" />
      {/* Winner line going to the right */}
      <path d="M12 12 H25" />
      {/* Seed dots — two on the left (the two teams entering), one on
          the right (the winner coming out). Makes it read as a bracket,
          not a field goal. */}
      <circle cx="3" cy="3" r="2" fill="currentColor" stroke="none" />
      <circle cx="3" cy="21" r="2" fill="currentColor" stroke="none" />
      <circle cx="25" cy="12" r="2" fill="currentColor" stroke="none" />
    </svg>
  );
}
